import React, { useState  } from 'react'
import { Link } from "react-router-dom";
import { Grid, Icon, Container, Divider,  Link as MUILink } from '@mui/material';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import TwitterIcon from '@mui/icons-material/Twitter';
import InstagramIcon from '@mui/icons-material/Instagram';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import DoubleArrow from '@mui/icons-material/DoubleArrow';
import Fab from '@mui/material/Fab';
import Zoom from '@mui/material/Zoom';
import MDBox from "dashboard/components/MDBox";
import MDTypography from "dashboard/components/MDTypography";

const LandingFooter = ({ data, logo, feed, navBar, about, limitTextToWords, parseContent }) => {
  const date = new Date();
  const [reachBottom, setReachBottom] = useState(false);
  const handleScroll = () => {

    const bottom = Math.ceil(window.innerHeight + window.scrollY) >= document.documentElement.scrollHeight - 2000

    if (bottom) {
      setReachBottom(true);
    }else{
      setReachBottom(false);
    }
  };
  React.useEffect(() => {
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  return (
    <MDBox id="footer" sx={{pt:3}}>
      <Container>
        <Grid spacing={2} container className="row" sx={{justifyContent:"center", pt:{xs:'.5rem !important', lg :'.5rem !important'}}}>
          <Grid item xs={12} md={6} lg={4} sx={{py:3}}>
            <MDBox component="img" src={`${process.env.REACT_APP_PUBLIC_URL}/img/logo/${logo}`} alt="logo" sx={{ maxWidth :"150px", verticalAlign : "top" }} />
            {about && <MDTypography sx={{my:2, fontWeight:400, fontSize:"13px"}} component="div">{parseContent(limitTextToWords(about.paragraphs[0]?.content, 60))}</MDTypography>}
          </Grid>
          <Grid item xs={12} md={6} lg={2} sx={{py:3}}>
            <MDTypography variant="h5" sx={{mb:2}}>Navigation</MDTypography>
            <List sx={{"& .MuiTypography-body2, & .MuiTypography-body1":{fontWeight:400, fontSize:15}, "& a":{color:"inherit", "&:hover":{border:"none !important"}}}}>
              {navBar && navBar.map(( item, index ) =>
                (<ListItem key={`footer-${index}-link`} disablePadding>
                  <ListItemButton sx={{px:1}}  dense >
                    <ListItemIcon sx={{minWidth:20}}>
                      <DoubleArrow />
                    </ListItemIcon>
                     <ListItemText className="truncate-text" primary={item.link?.type === 2 ? (<a  data-scroll href={`#${item.link.name}`}  style={{ textAlign: 'center', cursor:"pointer" }}>
                     {item.icon && <Icon sx={{mt:.5, mr:1}}>{item.icon.name}</Icon>}{item.title}
                   </a>) : <MDTypography sx={{ textAlign: 'center', cursor:"pointer" }} component={Link} to={`${item.link?.slug}`} >{item.icon && <Icon sx={{mt:.5, mr:1}}>{item.icon.name}</Icon>} {item.title}</MDTypography>}/>
                  </ListItemButton>
                </ListItem>))}
            </List>
          </Grid>
          <Grid item xs={12} md={6} lg={3} sx={{py:3}}>
            <MDTypography variant="h5" sx={{mb:2}}>Actualité</MDTypography>
            <List  dense sx={{"& .MuiTypography-body2":{fontWeight:400}, "& .MuiTypography-root" : { lineHeight :"15px"}, '& .MuiListItemText-root':{p:.5, pl:1}}}>
            {feed && feed.cards.map(( d, index ) => index < 3 && (
              <React.Fragment key={`footer-${index}-feed`}>
              <ListItem  disablePadding>
                <ListItemIcon sx={{minWidth:20}}>
                  <MDBox component="img" sx={{width:"50px", height :"50px"}} src={`${process.env.REACT_APP_PUBLIC_URL}/img/features/thumbs/thumb_${d.img}`} />
                </ListItemIcon>
                <ListItemText component="div" sx={{display : "inline-block"}}  primary={<span style={{fontSize:13, fontWeight : 600, color:"#23346a"}} className='truncate-text'>{d.title}</span>} secondary={<MDTypography component="span" sx={{display:"inline-block", mt : "5px!important", lineHeight : "12px"}} variant="caption">{parseContent(limitTextToWords(d.text,15))}</MDTypography>} />
              </ListItem>
              {index < 2  && <Divider  sx={{width:"100%",my:.75}}/>}
              </React.Fragment>))}
            </List>
          </Grid>
          <Grid item xs={12} md={6} lg={3} sx={{py:3}}>
            <MDTypography  variant="h5" sx={{mb:2}}>Contact</MDTypography>
            <List dense sx={{"& .MuiTypography-body2,& p, & span, & h1":{fontWeight:400, color:({palette:{text}})=>`${text.main} !important`}}}>
              <ListItem  disablePadding>
                <ListItemIcon sx={{minWidth:20}}><Icon>location_on</Icon></ListItemIcon>
                <ListItemText  primary={parseContent(data.address)} />
              </ListItem>
              <Divider  sx={{width:"100%",my:1}}/>
              <ListItem  disablePadding>
                <ListItemIcon sx={{minWidth:20}}><Icon>phone</Icon></ListItemIcon>
                <ListItemText   primary={<MDBox sx={{display:"inline-block", lineHeight:"normal"}}> {data ? data.phone.split(',').map( (item,i) => (
                      <React.Fragment key={`phl-${i}`}><span>{item}</span><br/></React.Fragment>
                    )) : "loading"}</MDBox>} />
              </ListItem>
              <Divider  sx={{width:"100%",my:1}}/>
              <ListItem  disablePadding>
                <ListItemIcon sx={{minWidth:20}}><Icon>email</Icon></ListItemIcon>
                <ListItemText   primary={<MDBox  sx={{display:"inline-block", lineHeight:"normal"}}> {data ? data.email.split(',').map( (item,i) => (
                      <React.Fragment key={`mal-${i}`}><span>{item}</span><br/></React.Fragment>
                    )) : "loading"}</MDBox>} />
              </ListItem>
            </List>
            <MDBox sx={{"& .material-icons-round, .MuiSvgIcon-root" : {border : ({palette: {text}})=> `1px solid ${text.main}`, color : ({palette: {text}})=>  `${text.main}`} }} className="social">
              <ul>
                <li>
                  <a href={data ? data.facebook : "/"}>
                  <Icon fontSize="small" >facebook</Icon>
                  </a>
                </li>
                <li>
                  <a href={data ? data.twitter : "/"}>
                  <TwitterIcon fontSize="small" />
                  </a>
                </li>
                <li>
                  <a href={data ? data.youtube : "/"}>
                  <InstagramIcon fontSize="small"/>
                  </a>
                </li>
              </ul>
            </MDBox>
          </Grid>
        </Grid>
      </Container>
      <MDBox sx={{backgroundColor:"#1e1e1e", color:"#999",  py:2}}>
        <Container sx={{textAlign:"center"}}><small>
            &copy; {date.getFullYear()}, created by{" "}
            <a href="https://www.digitalpartner.dz" rel="nofollow">
             Digital-Partner
            </a>   All rights reserved</small>
        </Container>
      </MDBox>
      <Zoom
          key="fab.color"
          in={reachBottom}
          timeout={{enter : 300, exit:200}}
          style={{
            transitionDelay: `${reachBottom ? 300 : 0}ms`,
          }}
          unmountOnExit
        >
          <Fab component="a" href="#page-top" sx={{
            position: 'fixed',
            bottom: 50,
            right: 16,
            
          }} variant="gradient" color="primary">
            <ExpandLessIcon />
          </Fab>
        </Zoom>
    </MDBox>
  )
}

export default LandingFooter